export default __webpack_public_path__ + "static/media/nasa_home.4eb49bdb.webp";